import DeliveryOption from '@/controllers/options/DeliveryOption';
import { IDeliveryOption } from '@/controllers/session/models/IQtiSession';

class DeliveryOptionsProvider {
  private _deliveryOptions: Array<DeliveryOption> = new Array<DeliveryOption>();

  get deliveryOptions(): Array<DeliveryOption> {
    return this._deliveryOptions;
  }
  addDeliveryOption(deliveryOption: DeliveryOption): boolean {
    if (
      this._deliveryOptions.findIndex((currentDeliveryOption) => currentDeliveryOption.name === deliveryOption.name) ===
      -1
    ) {
      this._deliveryOptions.push(deliveryOption);
      return true;
    }
    return false;
  }

  getDeliveryOptionsToSave(): Array<IDeliveryOption> | undefined {
    const convertedDeliveryOptions: Array<IDeliveryOption> = this.deliveryOptions
      .map((deliveryOption) => deliveryOption.toDeliveryInterface())
      .filter((deliveryOption) => deliveryOption.settings.size > 0);

    return convertedDeliveryOptions.length > 0 ? convertedDeliveryOptions : undefined;
  }
}

export default DeliveryOptionsProvider;
